// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.I2OkuyLHkTegpCOX_LQf{text-decoration:none}`, "",{"version":3,"sources":["webpack://./src/pages/settings/ui/LinkButton/styles.module.scss"],"names":[],"mappings":"AAAA,sBACE,oBAAA","sourcesContent":[".linkButton {\n  text-decoration: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"linkButton": `I2OkuyLHkTegpCOX_LQf`
};
export default ___CSS_LOADER_EXPORT___;
